// News behaviour: category filter (apps/site/components/news-explorer.tsx) and the
// click-to-play video preview (components/news-video.tsx).
(() => {
  document.querySelectorAll('[data-jola-news-explorer]').forEach((explorer) => {
    const buttons = explorer.querySelectorAll('.news-filters button');
    const cards = explorer.querySelectorAll('.news-card');
    const count = explorer.querySelector('[data-jola-news-count]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const category = button.dataset.category;
        let visible = 0;
        buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
        cards.forEach((card) => {
          const show = !category || card.dataset.category === category;
          card.hidden = !show;
          if (show) visible += 1;
        });
        count.textContent = `${visible} ${visible === 1 ? 'story' : 'stories'}`;
      });
    });
  });

  document.querySelectorAll('[data-jola-news-video]').forEach((button) => {
    button.addEventListener('click', () => {
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${button.dataset.videoId}?autoplay=1&rel=0&playsinline=1`;
      iframe.title = button.dataset.title;
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allowFullscreen = true;
      button.replaceWith(iframe);
    });
  });
})();
